module.exports = __webpack_public_path__ + "static/media/6-10.50ddd615.mp3";